<div class="controls">
  <div class="time">
    <label class="mode-label">At</label>
    <div class="time-controls">
      <mat-select
        (selectionChange)="onTimeChanged()"
        [(value)]="selectedHour"
        class="hours"
        data-test="schedule-hour-selector"
      >
        <mat-select-trigger>{{ selectedHour.displayValue }}</mat-select-trigger>
        <mat-option class="option" *ngFor="let hour of hours" [value]="hour" [attr.data-test]="hour.displayName">{{
          hour.displayName
        }}</mat-option>
      </mat-select>

      <mat-select
        (selectionChange)="onTimeChanged()"
        [(value)]="selectedMinute"
        class="minutes"
        data-test="schedule-minute-selector"
      >
        <mat-select-trigger
          >{{ selectedMinute.displayValue }} {{ selectedHour.value < 12 ? 'am' : 'pm' }}</mat-select-trigger
        >
        <mat-option
          class="option"
          *ngFor="let minute of minutes"
          [value]="minute"
          [attr.data-test]="minute.displayName"
          >{{ minute.displayName }}</mat-option
        >
      </mat-select>
    </div>
  </div>

  <div class="time-zone">
    <label class="mode-label visually-hidden">Time Zone</label>
    <mat-select
      (selectionChange)="onTimeChanged()"
      [(value)]="selectedTimeZone"
      data-test="schedule-time-zone-selector"
      class="time-zone-selector"
    >
      <mat-option
        class="option"
        *ngFor="let timeZone of commonTimeZones"
        [value]="timeZone.value"
        [attr.data-test]="timeZone.displayName"
        >{{ timeZone.displayName }}</mat-option
      >
      <mat-divider></mat-divider>
      <mat-option
        class="option"
        *ngFor="let timeZone of timeZones"
        [value]="timeZone.value"
        [attr.data-test]="timeZone.displayName"
        >{{ timeZone.displayName }}</mat-option
      >
    </mat-select>
  </div>
</div>
